var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHomeExplore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "67.817%",
    y1: "6.913%",
    x2: "34.12%",
    y2: "88.623%",
    id: "icon-home-explore_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38358F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC1FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 59.5,
    cy: 59.5,
    r: 59.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.073 59A24.24 24.24 0 0135 45.5C35 31.969 45.969 21 59.5 21S84 31.969 84 45.5c0 5.002-1.5 9.64-4.073 13.5h.023L59.475 98 39 59h.073zM59.5 54a9.5 9.5 0 100-19 9.5 9.5 0 000 19z",
    fill: "url(#icon-home-explore_svg__a)"
  }))));
}

export default SvgIconHomeExplore;